interface TextInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  required?: boolean;
  touched?: boolean;
  error?: string | boolean;
  errorMessage?: string;
  type?: string;
  maxLength?: number;
  isTextArea?: boolean;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  helperText?: string;
  inputMode?: 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
  'aria-label'?: string;
}

const TextInput = ({ 
  label, 
  value,
  onChange,
  onBlur,
  required, 
  touched, 
  error,
  errorMessage,
  type = "text",
  maxLength,
  placeholder,
  isTextArea = false,
  disabled,
  readOnly,
  helperText,
  inputMode,
  'aria-label': ariaLabel,
}: TextInputProps) => {
  const inputProps = {
    value,
    onChange,
    onBlur,
    type,
    maxLength,
    disabled,
    readOnly,
    className: `w-full p-2 border rounded-lg ${
      disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' :
      error ? 'border-semanticColors-error' : 
      touched ? 'border-green-500' : 
      'border-gray-300'
    } ${error ? 'focus:ring-semanticColors-error' : 'focus:ring-blue-500'} focus:outline-none focus:ring-2`,
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-2">
        {label}
        {required && !touched && <span className="text-gray-400 ml-1">*</span>}
        {required && touched && !error && <span className="text-green-500 ml-1">✓</span>}
      </label>
      {isTextArea ? (
        <textarea {...inputProps} rows={4} />
      ) : (
        <input {...inputProps} placeholder={placeholder} />
      )}
      {error && errorMessage && <p className="text-semanticColors-error text-sm mt-1">{errorMessage}</p>}
      {error && !errorMessage && typeof error === 'string' && (
        <p className="text-semanticColors-error text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default TextInput; 